export const ApiMeta = (json: IApiMeta): IApiMetaModel => {
	const fromJSON = (json: IApiMeta) => {
		const { current_page, last_page, per_page, ...rest } = json
		return {
			currentPage: current_page,
			lastPage: last_page,
			perPage: per_page,
			...rest,
		}
	}
	return { ...fromJSON(json) }
}
